import { TranslationsContext } from '@teliaee/telia-translate';
import * as React from 'react';
import { Notice } from 'telia-front-react';
import { ReservationError } from './ReservationInterfaces';

interface ReservationErrorNoticeProps {
  status: string;
  errors: ReservationError[];
}

const ReservationErrorNotice = (props: ReservationErrorNoticeProps): React.JSX.Element => {
  const { errors, status } = props;
  const { translate } = React.useContext(TranslationsContext);

  return (
    <Notice id="reservation-error-notice" type="error" align="center" attributes={{ 'aria-live': 'assertive', 'aria-atomic': 'true' }}>
      {errors.map((e: ReservationError) => (
        <p>{translate(`reservation.errors.${e.code}`)}</p>
      ))}
      {status === 'ERROR' && <p>{translate('reservation.errors.generalError')}</p>}
    </Notice>
  );
};

export default ReservationErrorNotice;
